import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import StructuredData from "./StructuredData";
import PageTransition from "./PageTransition";
import CartDrawer from "./CartDrawer";
import { useCart } from "@/contexts/CartContext";

const Layout = () => {
  const location = useLocation();
  const { cartOpen, setCartOpen } = useCart();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <StructuredData />
      <Navbar />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
      <main className="flex-1 relative">
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Layout;
